import React, { useState, useCallback } from 'react';
import { IDeleteSSOConfigDialogResult } from 'types/dialogs';
import DeleteSSOConfigDialog from './DeleteSSOConfigDialog';

const useDeleteSSOConfigDialog = () => {
	const [deleteSSOConfigDialogJsx, setDeleteSSOConfigDialogJsx] =
		useState<React.JSX.Element | null>(null);

	const openDeleteSSOConfigDialog = useCallback(
		() =>
			new Promise<IDeleteSSOConfigDialogResult>((resolve) => {
				setDeleteSSOConfigDialogJsx(
					<DeleteSSOConfigDialog
						onClose={(res) => {
							setDeleteSSOConfigDialogJsx(null);
							resolve(res);
						}}
					/>
				);
			}),
		[]
	);

	return { deleteSSOConfigDialogJsx, openDeleteSSOConfigDialog };
};

export default useDeleteSSOConfigDialog;
